import * as React from 'react';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { ButtonBase } from "@mui/material";
import { ReactComponent as LoginButtonSvg } from '../../../images/ms-symbollockup_signin_light.svg';
import { useConfig } from '../../../configContext';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

function LoginButton() {

  const config = useConfig();

  return (
    <ButtonBase
      disableRipple
      onClick={() =>  {
        var returnPath = `${config.BaseBffUrl}/auth/login?returnUrl=/`;
        window.location.assign(returnPath);
      }}
      sx={{
        width: 200,
        height: 40,
        borderRadius: 0,
        border: "1px solid transparent",
        "&:hover": {
          borderColor: "primary.main",
        },
        alignSelf:'center'
      }}
    >
       <LoginButtonSvg width={200} />
    </ButtonBase>
  );
}

export default function SignInCard() {
  return (
    <Card variant="outlined">
      <Box sx={{ display: { xs: 'flex' } }}>
        <img src="/logo.png" alt="Logo" style={{ height: 40, paddingBottom:0 }} />  
      </Box>

      <Typography
        component="h1"
        variant="h4"
        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
      >
        Welcome!
      </Typography>

      <Typography
        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
      >
        In order to use the Harvey portal, you will need to sign into your Microsoft Azure account.  Once logged in you cam use the portal.
      </Typography>
      
       <LoginButton/>
      
    </Card>
  );
}